import { styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    max-width: 1440px;
    margin: auto;
`;

export const ClaimExperienceContainer = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;

    @media screen and (max-width: 1400px) {
        align-items: center;
        justify-content: center;
    }

    @media screen and (max-width: 780px) {
        margin-bottom: -200px;
    }

    @media screen and (max-width: 400px) {
        margin-bottom: -140px;
    }
`;

export const ExperienceItem = styled.div`
    display: flex;
    flex-direction: column;
    padding: 40px;
    margin-top: 80px;
    margin-left: 140px;
    @media screen and (max-width: 780px) {
        margin: 0;
        padding: 20px;
    }
`;

export const ImageItem = styled.div`
    @media screen and (max-width: 780px) {
        position: relative;
        top: -220px;
    }

    @media screen and (max-width: 400px) {
        position: relative;
        top: -160px;
    }
`;

export const Title = styled.div`
    display: flex;
    font-weight: bold;
    font-size: 30px;
    line-height: 36px;
    color: #414a53;
    margin-bottom: 12px;
    @media screen and (max-width: 780px) {
        justify-content: center;
        margin-top: 20px;
        padding: 0 40px;
        text-align: center;
        font-size: 26px;
        letter-spacing: 0.02em;
        line-height: 31px;
    }
`;

export const ClaimItemWrapper = styled.div`
    display: flex;
    margin-top: 24px;
`;

export const ClaimItemIconWrapper = styled.div`
    display: flex;
`;

export const ClaimItemText = styled.div`
    display: flex;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    align-items: center;
    color: #5d607c;
    margin-left: 21px;
`;
